import { useCallback } from 'react'
import { ILeadOppProduct } from '@user/store/leadOppProducts'

export function useHandlers() {
  const getMonthlyPayment = useCallback((service: ILeadOppProduct) => {
    const { totalSubsequent, chargeTax, taxRate } = service

    const subsequentYearTotal: number = +totalSubsequent.toFixed(2)
    const subsequentYearSalesTax: number = chargeTax
      ? +(taxRate * totalSubsequent).toFixed(2)
      : 0
    return +(
      (subsequentYearTotal +
        (chargeTax
          ? subsequentYearSalesTax < 0
            ? 0
            : subsequentYearSalesTax
          : 0)) /
      12
    ).toFixed(2)
  }, [])

  return {
    getMonthlyPayment,
  }
}
